function quadIn(t) {
  return t * t
}

module.exports = quadIn